export const queryAllData = `
      id
      type
      name
      parentId
      residentId
      remark
    `;

export const queryStationsAndLivingAreas = `
  id
  name
  type
`;
